/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react"
import { Link, NavLink } from "react-router-dom"
import { getAssetPath } from "../../utils/assets"

function BackendHeader({ currentUser }) {
  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light">
      <Link
        className="navbar-brand"
        to="/backend">
        <img src={getAssetPath("logo")} className="ss-logo" alt="Strive Stronger Logo" />
      </Link>
      <button
        aria-controls="backendNavbar"
        aria-expanded="false"
        aria-label="Toggle navigation"
        className="navbar-toggler"
        data-target="#backendNavbar"
        data-toggle="collapse"
        type="button">
        <span className="navbar-toggler-icon" />
      </button>
      <div className="collapse navbar-collapse" id="backendNavbar">
        <ul className="navbar-nav mr-auto">
          <li className="nav-item">
            <NavLink end className="nav-link header-link" to="/backend">
              Programs
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link header-link" to="/backend/organisations">
              Organisations
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link header-link" to="/backend/users">
              Users
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link header-link" to="/backend/templates">
              Templates
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link header-link" to="/backend/exports">
              Exports
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link header-link" to="/backend/tags">
              Tags
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link header-link" to="/backend/activity-logs">
              Activity Logs
            </NavLink>
          </li>
        </ul>
        <ul className="navbar-nav">
          <li className="nav-item dropdown">
            <a
              aria-expanded="false"
              aria-haspopup="true"
              className="nav-link dropdown-toggle"
              data-toggle="dropdown"
              href="#"
              id="navbarDropdown"
              role="button">
              <span>{currentUser?.firstname}</span>
            </a>
            <div aria-labelledby="navbarDropdown" className="dropdown-menu dropdown-menu-right">
              <Link
                className="dropdown-item"
                to="/">
                Home
              </Link>
              <Link
                className="dropdown-item"
                to="/settings">
                Settings
              </Link>
              <Link
                className="dropdown-item"
                to="/enrol">
                Enrol
              </Link>
              <a className="dropdown-item" href="https://www.performanceintelligence.com/terms-of-use">Terms of Use</a>
              <a className="dropdown-item" href="https://www.performanceintelligence.com/privacy-policy"> Privacy Policy</a>
              <div className="dropdown-divider" />
              <Link
                className="dropdown-item"
                to="/logout"
                onClick={() => { window.location.href = "/logout" }}>
                Log out
              </Link>
            </div>
          </li>
        </ul>
      </div>
    </nav>
  )
}

export default BackendHeader
